import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmpersandAndTextComponent } from './ampersand-and-text/ampersand-and-text.component';
import { CarouselComponent } from './carousel/carousel.component';
import { FaqsComponent } from './faqs/faqs.component';
import { FloatingTilesComponent } from './floating-tiles/floating-tiles.component';
import { HeroMediaComponent } from './hero-image/hero-media.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { LargeItemCardsComponent } from './large-item-cards/large-item-cards.component';
import { PromoBlockComponent } from './promo-block/promo-block.component';
import { PromoModalComponent } from './promo-modal/promo-modal.component';
import { StarDividerComponent } from './star-divider/star-divider.component';
import { JotformBlockComponent } from './jotform-block/jotform-block.component';
import { JumpToSectionComponent } from './jump-to-section/jump-to-section.component';
import { ImageTilesComponent } from './image-tiles/image-tiles.component';
import { TextCTAComponent } from './text-cta/text-cta.component';
import { SideBySideImageTextComponent } from './sideBySideImageText/side-by-side-image-text.component';
import { TextBlockComponent } from './text-block/text-block.component';
import { NowPlayingComponent } from './now-playing/now-playing.component';
import { InfoBarComponent } from '../info-bar/info-bar.component';
import { InfoCarouselComponent } from './info-carousel/info-carousel.component';
import { FilmSelectorComponent } from './film-selector/film-selector.component';
import { TimelineComponent } from './timeline/timeline.component';
import { SmallCardsComponent } from './small-card/small-card.component';
import { SideBySideCarouselTextComponent } from './side-by-side-carousel-text/side-by-side-carousel-text.component';
import { TextByTextCardComponent } from './text-by-text-card/text-by-text-card.component';
import { SideBySideCarouselDynamicTextComponent } from './side-by-side-carousel-dynamic-text/side-by-side-carousel-dynamic-text.component';
import { PromoStayInTouchFormComponent } from './promo-stay-in-touch-form/promo-stay-in-touch-form.component';
import { ShowDetailsComponent } from './show-details/show-details.component';
import { MobileCtaComponent } from './mobile-cta/mobile-cta.component';
import { DonationFormComponent } from './donation-form/donation-form.component';
import { DuoSelectorComponent } from './duo-selector/duo-selector.component';
import { ShowCTABlockComponent } from './show-cta-block/show-cta-block.component';

@NgModule({
  imports: [
    CommonModule,
    AmpersandAndTextComponent,
    CarouselComponent,
    FaqsComponent,
    FloatingTilesComponent,
    HeroMediaComponent,
    InfoModalComponent,
    LargeItemCardsComponent,
    PromoBlockComponent,
    PromoModalComponent,
    StarDividerComponent,
    JotformBlockComponent,
    JumpToSectionComponent,
    ImageTilesComponent,
    TextCTAComponent,
    SideBySideImageTextComponent,
    FilmSelectorComponent,
    TextBlockComponent,
    NowPlayingComponent,
    InfoBarComponent,
    InfoCarouselComponent,
    TimelineComponent,
    SmallCardsComponent,
    SideBySideCarouselTextComponent,
    TextByTextCardComponent,
    SideBySideCarouselDynamicTextComponent,
    PromoStayInTouchFormComponent,
    ShowDetailsComponent,
    MobileCtaComponent,
    DonationFormComponent,
    DuoSelectorComponent,
    ShowCTABlockComponent,
  ],
  exports: [
    AmpersandAndTextComponent,
    CarouselComponent,
    FaqsComponent,
    FloatingTilesComponent,
    HeroMediaComponent,
    InfoModalComponent,
    LargeItemCardsComponent,
    PromoBlockComponent,
    PromoModalComponent,
    StarDividerComponent,
    JotformBlockComponent,
    JumpToSectionComponent,
    ImageTilesComponent,
    TextCTAComponent,
    SideBySideImageTextComponent,
    FilmSelectorComponent,
    TextBlockComponent,
    NowPlayingComponent,
    InfoBarComponent,
    InfoCarouselComponent,
    TimelineComponent,
    SmallCardsComponent,
    SideBySideCarouselTextComponent,
    TextByTextCardComponent,
    SideBySideCarouselDynamicTextComponent,
    PromoStayInTouchFormComponent,
    ShowDetailsComponent,
    MobileCtaComponent,
    DonationFormComponent,
    DuoSelectorComponent,
    ShowCTABlockComponent,
  ],
})
export class BuildingBlocksModule {}
